/**
 * How a person is named on screen.
 *
 * Its own Angular-free module so the rule can be tested directly: the two
 * places that did this inline both wrote `first + ' ' + last` and trimmed the
 * result, which silently produces a double space when one half arrives with
 * its own whitespace, and is what a person with only one half filled in
 * depends on.
 */
export function personDisplayName(person: {
  firstName?: string | null;
  lastName?: string | null;
}): string {
  return [person.firstName, person.lastName]
    .map((part) => part?.trim() ?? '')
    .filter((part) => part.length > 0)
    .join(' ');
}
